function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock-hi-dark_svg__a",
  x1: 89.18,
  y1: 61.86,
  x2: 128.99,
  y2: 101.66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock-hi-dark_svg__b",
  x1: 98.69,
  y1: 52.1,
  x2: 98.81,
  y2: 52.1,
  xlinkHref: "#clock-hi-dark_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock-hi-dark_svg__c",
  x1: 93.06,
  y1: 128.82,
  x2: 181.32,
  y2: 128.82,
  xlinkHref: "#clock-hi-dark_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "clock-hi-dark_svg__d",
  x1: 107.02,
  y1: 84.77,
  x2: 168.9,
  y2: 146.65,
  xlinkHref: "#clock-hi-dark_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 96,
  cy: 96,
  r: 80,
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h192v192H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  fill: "none",
  stroke: "#4a4d4e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M166.03 96H154.5M96 37V25.77M96 166.03V154.5M25.97 96H37.5"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.24,
  fill: "none",
  stroke: "#4a4d4e",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M126.09 43.3l4.58-8.29M148.77 65.29l7.91-4.62M148.7 126.09l8.29 4.58M126.71 148.77l4.62 7.91M65.91 148.7l-4.58 8.29M43.23 126.71l-7.91 4.62M43.3 65.91l-8.29-4.58M65.29 43.23l-4.62-7.91"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  fill: "none",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "M96 96h44.5M96 96V55"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M140.5 98H96a4 4 0 01-4-4v2a4 4 0 004 4h44.5a4 4 0 003.86-5 4 4 0 01-3.86 3z",
  fill: "#333",
  opacity: 0.12
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M96 26a70 70 0 11-70 70 70.08 70.08 0 0170-70m0-10a80 80 0 1080 80 80 80 0 00-80-80z",
  fill: "#ebebeb"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.06,
  fill: "#333"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96 24a70.08 70.08 0 00-70 70v1a70 70 0 01140 0v-1a70.08 70.08 0 00-70-70zM96 174a80 80 0 01-80-79v1a80 80 0 00160 0v-1a80 80 0 01-80 79z"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M138.65 92l-39.8-39.81A4 4 0 01100 55v37z",
  opacity: 0.2,
  fill: "url(#clock-hi-dark_svg__a)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M98.81 52.15l-.1-.1z",
  opacity: 0.2,
  fill: "url(#clock-hi-dark_svg__b)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M96 26a70 70 0 1046.55 122.22L93.06 98.73A4 4 0 0096 100h44.5a4 4 0 002.86-6.79l20.38 20.38A70 70 0 0096 26z",
  fill: "none"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M169 128.75l-.06.14z",
  opacity: 0.2,
  fill: "url(#clock-hi-dark_svg__c)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M143.36 93.21a4 4 0 01-2.86 6.79H96a4 4 0 01-2.91-1.27l49.49 49.49a70.08 70.08 0 0021.21-34.63l-20.41-20.38z",
  opacity: 0.2,
  fill: "url(#clock-hi-dark_svg__d)"
});

var SvgClockHiDark = function SvgClockHiDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "clock-hi",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

export default SvgClockHiDark;